document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.fx-products-menu[open], .fx-guides-menu[open], .fx-mobile-menu[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.fx-products-menu[open], .fx-guides-menu[open], .fx-mobile-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a[href]')) menu.open = false;
  });
});

document.querySelectorAll('[data-product-gallery], [data-factory-gallery]').forEach((gallery) => {
  const factoryGallery = gallery.hasAttribute('data-factory-gallery');
  const openButtons = factoryGallery ? [...document.querySelectorAll('[data-factory-image]')] : [gallery.querySelector('[data-gallery-open]')];
  if (!openButtons.length) return;
  let returnButton = openButtons[0];
  const mainImage = returnButton.querySelector('img');
  const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
  const images = factoryGallery ? openButtons : thumbnails.length ? thumbnails : openButtons;
  const dialog = gallery.querySelector('[data-gallery-dialog]');
  const fullImage = dialog.querySelector('img');
  const stage = dialog.querySelector('[data-gallery-stage]');
  const zoomButton = dialog.querySelector('[data-gallery-zoom]');
  let active = Math.max(0, images.findIndex((image) => image.getAttribute('aria-pressed') === 'true'));
  let previousOverflow = '';
  dialog.querySelector('[data-gallery-previous]').hidden = images.length < 2;
  dialog.querySelector('[data-gallery-next]').hidden = images.length < 2;

  const resetZoom = () => {
    stage.classList.remove('is-zoomed');
    zoomButton.setAttribute('aria-pressed', 'false');
    stage.scrollTo(0, 0);
  };

  const restorePage = () => {
    if (dialog.open) return;
    resetZoom();
    document.body.style.overflow = previousOverflow;
    returnButton.focus({ preventScroll: true });
  };

  const closeDialog = () => {
    dialog.close();
    restorePage();
  };

  const showImage = (index) => {
    active = (index + images.length) % images.length;
    const source = images[active];
    if (source.dataset.galleryPreviewSrc) {
      mainImage.srcset = source.dataset.galleryPreviewSrcset;
      mainImage.src = source.dataset.galleryPreviewSrc;
      mainImage.width = Number(source.dataset.galleryWidth);
      mainImage.height = Number(source.dataset.galleryHeight);
      mainImage.alt = source.querySelector('img').alt;
    }
    thumbnails.forEach((thumbnail, i) => thumbnail.setAttribute('aria-pressed', String(i === active)));
    dialog.querySelector('[data-gallery-count]').textContent = `${active + 1} / ${images.length}`;
    if (dialog.open) {
      resetZoom();
      const sourceImage = factoryGallery ? source.querySelector('img') : mainImage;
      fullImage.removeAttribute('srcset');
      fullImage.src = source.dataset.galleryFullSrc;
      fullImage.alt = sourceImage.alt;
      fullImage.width = Number(source.dataset.galleryWidth) || sourceImage.naturalWidth;
      fullImage.height = Number(source.dataset.galleryHeight) || sourceImage.naturalHeight;
      if (factoryGallery) dialog.querySelector('[data-gallery-title]').textContent = source.dataset.galleryCaption;
    }
  };

  thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => showImage(index)));
  openButtons.forEach((button, index) => button.addEventListener('click', () => {
    returnButton = button;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    showImage(factoryGallery ? index : active);
  }));
  dialog.querySelector('[data-gallery-close]').addEventListener('click', closeDialog);
  dialog.querySelector('[data-gallery-previous]').addEventListener('click', () => showImage(active - 1));
  dialog.querySelector('[data-gallery-next]').addEventListener('click', () => showImage(active + 1));
  zoomButton.addEventListener('click', () => {
    const zoomed = stage.classList.toggle('is-zoomed');
    zoomButton.setAttribute('aria-pressed', String(zoomed));
    stage.scrollTo(0, 0);
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      const controls = [...dialog.querySelectorAll('button:not([hidden]):not(:disabled)')];
      const target = event.shiftKey ? controls.at(-1) : controls[0];
      const edge = event.shiftKey ? controls[0] : controls.at(-1);
      if (document.activeElement === edge) {
        event.preventDefault();
        target.focus();
      }
      return;
    }
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || stage.classList.contains('is-zoomed')) return;
    event.preventDefault();
    showImage(active + (event.key === 'ArrowRight' ? 1 : -1));
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });
  dialog.addEventListener('close', restorePage);
});
